import http from '@/services/http'
import { groupGoodsUrl } from '@/services/url'
import type { SkuGroupSearchRes } from './type'

// interface GroupGoodsListRes<T> {
//   list: T
//   pageNum: number
//   pageSize: number
//   total: number
// }
// interface SkuGroupSearchReqDTO {
//   /**语言 */
//   language?: string
//   /**页码，从1开始,  默认1 ，上限各自判断（约束：大于等于1） */
//   pageNum?: number
//   /**分页大小，默认20， 上限各自判断（约束：大于等于1；小于等于500） */
//   pageSize?: number
//   /**商品组名称 */
//   skuGroupName?: string
//   /**商品组id */
//   skuGroupIds?: string[]
//   /**商品组状态 */
//   enabled?: boolean
//   /**库存模式。 */
//   stockModel?: string
// }

interface GroupGoodsParams {
  language?: string
  skuGroupId: string
}

/** 创建组合商品 */
export const createGroupGoodsApi = async (data) => await http.admin.post(groupGoodsUrl.createGroupGoods, data)

/** 上下架组合商品 */
export const updateGroupGoodsStatusApi = async (data) => await http.admin.post(groupGoodsUrl.updateGroupGoodsStatus, data)

/** 更新组合商品 */
export const updateGroupGoodsApi = async (data) => await http.admin.post(groupGoodsUrl.updateGroupGoods, data)

/**查询组合商品列表 */
export const searchGroupGoodsApi = async (data) => await http.admin.post<SkuGroupSearchRes>(groupGoodsUrl.searchGroupGoods, data)

export interface IGroupGoodsDetailParams {
  skuGroupId?: string
}
export const getGroupGoodDetailApi = async (params: IGroupGoodsDetailParams) => await http.admin.get(groupGoodsUrl.getGroupGoodDetail, { params })
/** 删除组合商品 */
export const deleteGroupGoods = async (params: GroupGoodsParams) => await http.admin.post(groupGoodsUrl.deleteGroupGoods, params)

/** 获取商家库存模式开关 */
export const getStockModelSwitch = async () => await http.admin.get('/api/sku-group/stock_model_switch')
/** 转换库存 */
export const convertStock = async (params) => await http.noToast.post('/api/sku-group/convert_stock', params)

/** 获取商家独享库存编辑的条件 */
export const getConvertCheck = async () => await http.admin.get('/api/stock/sync/rule/auto/convert/check')
